import React, { Fragment, useMemo, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Row, Select } from 'antd';
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaJournalWhills } from "react-icons/fa";

import '../css/collasible.css';
import ReportsToPDF from '../components/ReportsToPDF';
import { BlobProvider } from '@react-pdf/renderer';
import { useLoaderData, useParams } from 'react-router-dom';
import GHSymbol from '../components/GHSymbol';


const options = [
  {
    value: 'jack',
    label: 'Jack',
  },
  {
    value: 'lucy',
    label: 'Lucy',
  },
  {
    value: 'Yiminghe',
    label: 'yiminghe',
  },
];

const data = [
  {
    "type": "sales",
    "reports": [
      {
        "_id": "5fabfe86-ed4b-4df2-b987-736b59b6ebde",
        "name": "Product Sales Taxes",
        "amount": 0
      },
      {
        "_id": "08ff510e-17af-482a-ba60-2a271bfb6382",
        "name": "Transit tax",
        "amount": 0
      }
    ]
  }
]



const TaxReports = () => {
  const [filter, setFilter] = useState({date: '', journal_code: ''})
  // const report = useLoaderData();
  // const params = useParams();

  const onChangeDate = (date, dateString) => setFilter({ ...filter, date: dateString });
  const onChangeJournal = (v) => setFilter({ ...filter, journal_code: v });
  

  // const memoizedDocument = useMemo(() => <ReportsToPDF data={report} reportType={params.id} />, []);


  return (
    <div className='container mx-auto h-full' style={{maxWidth: '900px'}}>
      <div className='bg-white mb-3 p-1'>
        <div>
          <h2 className='font-semibold text-xl text-[#04949b]'>{'Tax Report'}</h2>
        </div>
        <div className='flex justify-between p-2'>
          <div>
            <Button className='bg-[#04949b] text-white border-0 hover:bg-[#04949b] font-semibold'>
              {/* <BlobProvider document={memoizedDocument}>
                  {({ url, loading, error }) => {
                    if (loading) return 'Loading document...';
                    if (error) return 'Error loading document';
                    return (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        PDF
                      </a>
                    );
                  }}
                </BlobProvider> */}
            </Button>
          </div>
          <Row className='w-1/2'>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaRegCalendarAlt className='me-1'/>As of</span>
              <DatePicker suffixIcon={false} defaultValue={filter.date} onChange={onChangeDate} className='border-x-0 border-t-0 ps-0 text-[#04949b] font-semibold focus:shadow-none input-outline-none w-full border-0 font-normal'/>
            </Col>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaJournalWhills className='me-1'/>Journals:</span>
              <Select variant="borderless" value={filter.journal_code} onChange={onChangeJournal} suffixIcon={false} className='w-full font-semibold text-[#04949b]' options={options}/>
            </Col>
          </Row>
        </div>
      </div>
      <div className='bg-white p-3'>
        <Collapse defaultActiveKey={['1']} ghost className='m-0 p-0' 
          items={data.map((report, ids) => {
            return (
              {
                key: report.id,
                label: 
                  <div key={report.id} className='flex justify-between font-medium'>
                    <p className='m-0 p-0 '>{report.type}</p>
                    <p className='m-0 p-0' style={{fontSize: '13.5px'}}><GHSymbol /> {0}</p>
                  </div>,
                children: report.reports.map(children=> {
                  return(
                    <div key={children.id} className='flex justify-between'>
                      <p className='m-0 p-0'>{children.name}</p>
                      <p className='m-0 p-0' style={{fontSize: '13px'}}><GHSymbol /> {children.amount}</p>
                    </div>
                  )
                })
              }
            )
          })}
        />
      </div>
    </div>
  )
};

export default TaxReports;